'use client';

import { type LucideIcon } from 'lucide-react';

import { useLocation, useNavigate } from 'react-router';
import { Collapsible, CollapsibleTrigger } from './ui/collapsible';
import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from './ui/sidebar';

export default function NavMain({
  items,
  name,
}: {
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
  }[];
  name: string;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathLocation = location.pathname.toLocaleLowerCase();

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{name}</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible key={item.title} asChild className="group/collapsible">
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                <SidebarMenuButton
                  tooltip={item.title}
                  isActive={pathLocation.includes(item.url)}
                  onClick={() => navigate(item.url)}
                >
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </SidebarMenuButton>
              </CollapsibleTrigger>
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
